import { NDT_UYARI_KALIPLARI } from "./ndt-raporu.js";
import { WELDMAP_UYARI_KALIPLARI } from "./weld-map.js";
import { kimlikSade } from "./sarf.js";
import { yuvarla3 } from "./stok-paket.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). */
export const TESLIM_BELGE_TURU = "teslim_listesi";
/** Okunan Documents türü (GELEN_TURLERI anahtarı, "Delivery note / packing list"; Registers grubu, kütük sınıfı). */
export const TESLIM_GELEN_TURU = "kutuk:stok_paket:teslim";
export const teslimGelenTuruMu = (t) => t === TESLIM_GELEN_TURU;
/** Olay kaydında nesne tipi (nesneId = teslim_listesi_kaydi.id). */
export const TESLIM_OLAY_NESNESI = "teslim_listesi_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir aile sorgusu bu adı almaz (Riser Documentation, kanıt zinciri ve aile işlemleri). */
export const TESLIM_GIRDI_AILESI = "Packing-list-input";
/** DOCUMENT sayfasındaki "Document type" değeri. */
export const TESLIM_EXCEL_ADI = "Packing list";
/** Bir listede en çok satır (`Line`). */
export const TESLIM_SATIR_EN_COK = 100;
/** Okuma işi kodu ("PL-5A1B2C3D"); "PKG-" paket no'larından ve "TES-" uyarı kodlarından ayrı. */
export const teslimKodu = (kayitId) => `PL-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/**
 * Başlık alanları (DOCUMENT, 3; sabit sıra; sözleşme §12.3, sürüm 1). Her alanın tüketicisi sözleşmede ve `teslim-karsilastirma.ts`'te (`TESLIM_OKUNAN`) yazılıdır. `etiket`
 * hem ekran metni hem DOCUMENT'teki Field adıdır. Kimlik: liste no.
 */
export const TESLIM_ALANLARI = [
    { alan: "liste_no", etiket: "List number", kimlik: true },
    { alan: "liste_tarihi", etiket: "List date", kimlik: false },
    { alan: "musteri_po", etiket: "Customer PO", kimlik: false },
];
/** Satır alanları (ROWS, satır başına 5; sabit sıra; sözleşme §12.3). Kimlik: PN, lot, SN. */
export const TESLIM_SATIR_ALANLARI = [
    { alan: "pn", etiket: "Part number", kimlik: true },
    { alan: "miktar", etiket: "Quantity", kimlik: false },
    { alan: "birim", etiket: "Unit", kimlik: false },
    { alan: "lot", etiket: "Lot", kimlik: true },
    { alan: "seri", etiket: "Serial numbers", kimlik: true },
];
/** Alanın ekran adı (iki listede aranır); bilinmiyorsa alanın kendisi. */
export const teslimEtiketi = (alan) => [...TESLIM_ALANLARI, ...TESLIM_SATIR_ALANLARI].find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (uzun biçim: her hücre bir satır; `Line` listenin satır sırası). */
export const TESLIM_SATIR_BASLIKLARI = ["Line", "Field", "Value", "As written", "Page", "Certainty"];
/** Kişinin onaylarının alanları (`belge_deger_onayi.alan`; kalemin parçasında, kalem başına bir kez). */
export const TESLIM_PAKET_ALANI = "stok_paketi";
export const TESLIM_LISTE_ALANI = "kutuk_satiri";
/** Okumadan açılan paketin kaynağı (`stok_paket.kaynak`). */
export const TESLIM_PAKET_KAYNAGI = "teslim_listesi";
/** Fit → metre (tanımı gereği tam katsayı). */
export const FT_M = 0.3048;
/** Kalemin durumunu ve yazımı durduran "okuma değişti" cümlesi (sunucu TESLIM_HATALARI.okumaDegisti ile aynı metin). */
export const TESLIM_OKUMA_DEGISTI_METNI = "The reading changed; refresh the page.";
/* ---------------- değer biçimleri (yalnız kesin değerler kullanılır) ---------------- */
/** PN'in karşılaştırma anahtarı: kırpılır, büyük harf, bütün boşluklar atılır (`kimlikSade` ile aynı). */
export const pnSade = (v) => kimlikSade(v);
const BIRIM_ESANLAMLARI = {
    EA: "ad", EACH: "ad", PC: "ad", PCS: "ad", PCE: "ad", AD: "ad", ADET: "ad", NO: "ad", NOS: "ad",
    M: "m", MT: "m", MTR: "m", METER: "m", METRE: "m", METERS: "m", METRES: "m",
    KG: "kg", KGS: "kg",
    FT: "ft", FEET: "ft", FOOT: "ft",
};
/** M2-8: birim yazısı → kod (büyük-küçük harfe ve sondaki noktaya duyarsız); başka her yazım null. */
export function birimKodu(v) {
    const s = (v ?? "").trim().replace(/\.+$/, "").toUpperCase();
    return s ? (BIRIM_ESANLAMLARI[s] ?? null) : null;
}
/** M2-8: miktarın katalog birimine çevrilmesi. Aynı birim aynen; yalnız ft → m (`yuvarla3(ft × 0.3048)`); başka her çeviri null (uydurulmaz). */
export function birimCevir(miktar, kod, katalog) {
    if (!kod)
        return null;
    if (kod === katalog)
        return { miktar: yuvarla3(miktar), birim: katalog };
    if (kod === "ft" && katalog === "m")
        return { miktar: yuvarla3(miktar * FT_M), birim: "m" };
    return null;
}
const MIKTAR = /^\d{1,7}(\.\d{1,3})?$/;
/** M2-7: `Quantity` değeri (ondalık nokta, en çok 7 hane ve 3 ondalık, sıfırdan büyük); öteki her yazım null. */
export function miktarOku(v) {
    const s = (v ?? "").trim();
    if (!MIKTAR.test(s))
        return null;
    const n = Number(s);
    return n > 0 ? n : null;
}
/** Bir SN'in en çok uzunluğu, listede en çok SN ve hücrenin tamamının en çok uzunluğu (M2-7; okunan değerin ortak 500 karakter sınırı, `okunanDegerHatasi`). */
export const TESLIM_SN_EN_UZUN = 60;
export const TESLIM_SN_EN_COK = 200;
export const TESLIM_SERI_EN_UZUN = 500;
/**
 * M2-7: `Serial numbers` değeri virgülle ayrılmış liste; boş öğe, 60 karakterden uzun SN, 200'den çok SN ya da 500 karakterden uzun hücre → null. Hücre sınırı okunan değerin
 * ortak sınırıdır: aşan liste genel "text too long" yerine bu kuralın cümlesiyle reddedilir. Aralık ("9990001-9990010") tek öğedir, açılmaz.
 */
export function seriListesi(v) {
    const s = (v ?? "").trim();
    if (!s || s.length > TESLIM_SERI_EN_UZUN)
        return null;
    const l = s.split(",").map((x) => x.trim());
    if (l.some((x) => !x || x.length > TESLIM_SN_EN_UZUN) || l.length > TESLIM_SN_EN_COK)
        return null;
    return l;
}
/** M2-10: paketin "heat / lot / SN" metninin parçaları (`,` `;` ya da satır sonuyla bölünür; `kimlikSade`; boşlar atılır). */
export function izParcalari(iz) {
    return (iz ?? "").split(/[,;\n]/).map((x) => kimlikSade(x)).filter(Boolean);
}
/** M2-16: yeni paketin "heat / lot / SN" metni: lot ve SN'ler belgede yazıldığı gibi (kırpılmış), virgülle; hiçbiri yoksa null. */
export function teslimIzMetni(lot, seriler) {
    const l = [lot?.trim() ?? "", ...seriler.map((s) => s.trim())].filter(Boolean);
    return l.length ? l.join(", ") : null;
}
/** Kimliklerin kısa metni: en çok `n` öğe, fazlası " …" ("9990001, 9990002, 9990003 …"). */
export function kimlikListesi(xs, n = 3) {
    return xs.length > n ? `${xs.slice(0, n).join(", ")} …` : xs.join(", ");
}
const degerOf = (l, alan) => l.find((x) => x.alan === alan) ?? null;
const kesinMi = (d) => Boolean(d && d.kesinlik === "kesin" && d.deger !== null && d.deger.trim() !== "");
/** Dolu değer şüpheli değil (boş değer kesinliği bozmaz). */
const supheliDegil = (d) => !d || d.kesinlik !== "suphe";
/**
 * M2-9: okunan satırlardan kalemler. PN ve lot ikisi de kesin ve dolu, birim aynıysa (kesin birimin kodu ya da yazısı; şüpheli birimde birleşme yok) aynı (PN, lot, birim)
 * satırları tek kaleme birleşir: miktar toplanır (yalnız hepsi kesinse), SN'ler sırayla birleşir. Öteki her satır kendi kalemidir; kalem sırası ilk satırının sırasıdır.
 * Aynı PN altında bir SN birden çok kez geçiyorsa o SN'i taşıyan kalemler `snTekrar` olur. Notlar: `birlesti`, `sn_tekrar`, `sn_sayisi`, `suphe`.
 */
export function teslimKalemleri(satirlar) {
    const sirali = [...satirlar].sort((a, b) => a.no - b.no);
    const gruplar = [];
    const anahtarlar = new Map();
    for (const s of sirali) {
        const pn = degerOf(s.degerler, "pn");
        const lot = degerOf(s.degerler, "lot");
        const birim = degerOf(s.degerler, "birim");
        let birimAnahtari = null;
        if (birim?.kesinlik === "bos" || !birim)
            birimAnahtari = "";
        else if (kesinMi(birim))
            birimAnahtari = birimKodu(birim.deger) ?? `#${birim.deger.trim().toUpperCase()}`;
        if (kesinMi(pn) && kesinMi(lot) && birimAnahtari !== null) {
            const k = JSON.stringify([pnSade(pn.deger), kimlikSade(lot.deger), birimAnahtari]);
            const g = anahtarlar.get(k);
            if (g) {
                g.push(s);
                continue;
            }
            const yeni = [s];
            anahtarlar.set(k, yeni);
            gruplar.push(yeni);
            continue;
        }
        gruplar.push([s]);
    }
    const notlar = [];
    const not = (n) => { if (!notlar.some((x) => JSON.stringify(x) === JSON.stringify(n)))
        notlar.push(n); };
    const kalemler = gruplar.map((g, i) => {
        const sira = i + 1;
        const ilk = g[0];
        const pn = degerOf(ilk.degerler, "pn");
        const lotD = degerOf(ilk.degerler, "lot");
        const birimD = degerOf(ilk.degerler, "birim");
        const seriler = [];
        let miktar = 0;
        let seriKesin = true;
        let miktarKesin = true;
        for (const s of g) {
            const sd = degerOf(s.degerler, "seri");
            if (kesinMi(sd))
                seriler.push(...(seriListesi(sd.deger) ?? [sd.deger.trim()]));
            if (!supheliDegil(sd))
                seriKesin = false;
            const md = degerOf(s.degerler, "miktar");
            const m = kesinMi(md) ? miktarOku(md.deger) : null;
            if (m === null) {
                miktar = null;
                miktarKesin = false;
            }
            else if (miktar !== null)
                miktar += m;
            for (const d of s.degerler)
                if (d.kesinlik === "suphe")
                    not({ tur: "suphe", kalem: sira, alan: d.alan });
        }
        const lot = kesinMi(lotD) ? lotD.deger.trim() : null;
        const kimlikler = [...new Set([...(lot ? [kimlikSade(lot)] : []), ...seriler.map((x) => kimlikSade(x))].filter(Boolean))];
        if (g.length > 1)
            not({ tur: "birlesti", kalem: sira, satirlar: g.map((s) => s.no) });
        return {
            sira, satirlar: g.map((s) => s.no), degerler: g.flatMap((s) => s.degerler), pn, pnSade: kesinMi(pn) ? pnSade(pn.deger) : null, lot, seriler, kimlikler,
            miktar: miktar === null ? null : yuvarla3(miktar), birim: kesinMi(birimD) ? birimKodu(birimD.deger) : null, birimYazisi: kesinMi(birimD) ? birimD.deger.trim() : null,
            kesin: { lot: supheliDegil(lotD), seri: seriKesin, miktar: miktarKesin, birim: kesinMi(birimD) || birimD?.kesinlik === "bos" },
            snTekrar: false,
        };
    });
    // SN tekrarı: aynı PN altında bir SN birden çok kez (bir satırda ya da iki satırda).
    const pnSnSayisi = new Map();
    for (const k of kalemler)
        if (k.pnSade)
            for (const s of k.seriler)
                pnSnSayisi.set(`${k.pnSade}|${kimlikSade(s)}`, (pnSnSayisi.get(`${k.pnSade}|${kimlikSade(s)}`) ?? 0) + 1);
    for (const k of kalemler) {
        if (!k.pnSade)
            continue;
        for (const s of k.seriler) {
            if ((pnSnSayisi.get(`${k.pnSade}|${kimlikSade(s)}`) ?? 0) > 1) {
                k.snTekrar = true;
                not({ tur: "sn_tekrar", kalem: k.sira, seri: s });
            }
        }
        if (k.birim === "ad" && k.seriler.length && k.miktar !== null && k.seriler.length !== k.miktar)
            not({ tur: "sn_sayisi", kalem: k.sira, sayi: k.seriler.length, miktar: k.miktar });
    }
    return { kalemler, notlar };
}
/* ---------------- uyarılar ---------------- */
/** Kartta üretilen kodlar (kalem içinde üretim sırası; parçasızlar GEN-15 ve GEN-09). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). TES-06 ve TES-07 üretilmez. */
export const TESLIM_UYARI_KODLARI = ["TES-01", "TES-02", "TES-03", "TES-04", "TES-05", "GEN-15", "GEN-09"];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). GEN-15 ve GEN-09 öteki okuyucularınkiyle aynıdır. */
export const TESLIM_UYARI_KALIPLARI = {
    "TES-01": "Part number not in the stock catalogue: {0}.",
    "TES-02": "Already received: {0} {1} is on {2}. Quantity not added again.",
    "TES-03": "Customer PO {0} differs from the stock package PO {1}.",
    "TES-04": "No 3.1 or CoC for {0} lot {1}.",
    "TES-05": "Quantity differs from the stock package: {0} / {1}.",
    "GEN-15": WELDMAP_UYARI_KALIPLARI["GEN-15"],
    "GEN-09": NDT_UYARI_KALIPLARI["GEN-09"],
};
/** Saf (M2-22): kartın durumu ve yazımın ön denetimi aynı kuraldır; ilk tutan döner. `engel` yalnız "engel" durumunda dolu. */
export function teslimKalemEngeli(d) {
    const ol = (durum, engel = null) => ({ durum, engel });
    if (d.kapali)
        return ol("kapali");
    if (d.neden === "pn_yok")
        return ol("pn_yok");
    if (d.neden === "katalogda_yok")
        return ol("katalogda_yok");
    if (d.neden === "alindi")
        return ol("alindi");
    if (d.neden === "celiski" || d.neden === "birden_cok" || d.neden === "iz_benzer")
        return ol("belirsiz");
    if (d.neden === "sn_tekrar")
        return ol("sn_tekrar");
    if (d.yerVar) {
        if (!d.okumaGuncel)
            return ol("engel", TESLIM_OKUMA_DEGISTI_METNI);
        if (d.engel)
            return ol("engel", d.engel);
        if (d.listeVar || d.listeOnay)
            return ol("liste_var");
        if (d.acik)
            return ol("dosyalanmadi");
        return ol("eklenebilir");
    }
    if (d.neden === "kimliksiz" || d.oneriKapisi === "kimliksiz")
        return ol("kimliksiz");
    if (d.oneriKapisi === "kesin_degil")
        return ol("kesin_degil");
    if (d.oneriKapisi === "birim_bilinmiyor")
        return ol("birim_bilinmiyor");
    if (d.oneriKapisi === "birim_farkli")
        return ol("birim_farkli");
    if (d.oneriKapisi === "sn_tekrar")
        return ol("sn_tekrar");
    if (d.oneriKapisi === "katalogda_yok")
        return ol("katalogda_yok");
    if (d.paketOnay)
        return ol("acildi");
    if (!d.okumaGuncel)
        return ol("engel", TESLIM_OKUMA_DEGISTI_METNI);
    if (d.engel)
        return ol("engel", d.engel);
    return ol("acilabilir");
}
//# sourceMappingURL=teslim-listesi.js.map